import React from 'react';
import { IntlProvider } from 'react-intl';
import translations from './translations.json';
import { LANGUAGES } from './languages.js';

function getLanguageFromUrl(url = '') {
    const cleanUrl = url.split('?')[0].split('#')[0];
    const parts = cleanUrl.split('/').filter(Boolean);

    // e.g. /pt
    if (parts.length === 1 && LANGUAGES[parts[0]] && parts[0] !== 'default') {
        return LANGUAGES[parts[0]];
    }

    // e.g. /replace-text/pt
    if (parts.length >= 2 && LANGUAGES[parts[1]] && parts[1] !== 'default') {
        return LANGUAGES[parts[1]];
    }

    // fallback search for any segment matching a language code
    for (let p of parts) {
        if (LANGUAGES[p] && p !== 'default') {
            return LANGUAGES[p];
        }
    }

    return LANGUAGES['en'];
}

export default class IntlProviderConfigured extends React.Component {
    state = {
        loading: true,
        locale: ''
    }
    localeSelected = undefined
    urlLang = ''

    componentDidMount() {
        const currentLanguage = getLanguageFromUrl(window.location.pathname);
        this.setState({ locale: currentLanguage.code, loading: false });
        if (typeof window !== 'undefined' && window.localStorage && currentLanguage.urlLang) {
            try {
                window.localStorage.setItem('user_lang', currentLanguage.urlLang);
            } catch (e) {
                // ignore localStorage security errors
            }
        }
    }

    static preInitStore(url) {
        return new Promise((resolve, reject) => {
            const currentLanguage = getLanguageFromUrl(url);
            IntlProviderConfigured.localeSelected = currentLanguage ? currentLanguage.code : 'en-US';
            this.urlLang = currentLanguage ? currentLanguage.urlLang : 'en';
            resolve(true);
        });
    }

    render() {
        const locale = this.state.locale !== '' ? this.state.locale : (IntlProviderConfigured.localeSelected || 'en-US');
        const { children } = this.props;

        if (this.state.loading && IntlProviderConfigured.localeSelected === undefined) return <div>...</div>;

        return (
            <IntlProvider locale={locale} messages={translations[locale] || translations['en-US']}>
                {children}
            </IntlProvider>
        );
    }
}